import React, { Fragment, useState, useEffect } from 'react';
import { useMutation } from '@apollo/client';
import { GET_LIBROS, ADD_LIBRO } from '../../graphql/actions/libro';
import axios from 'axios';
// nodejs library that concatenates classes
import classNames from 'classnames';
// react components for routing our app without refresh
import { withRouter } from 'react-router-dom';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
// @material-ui/icons
// core components
import GridContainer from '../UI/Grid/GridContainer';
import GridItem from '../UI/Grid/GridItem';
import CustomInput from '../UI/CustomInput/CustomInput';
import CustomFileInput from '../UI/CustomFileInput/CustomFileInput';
import Badge from '../UI/Badge/Badge';
import Button from '../UI/CustomButtons/Button';
import Spinner from '../UI/Spinner/Spinner';
import Notification from '../Notification/Notification';
// Validations
import { isEmpty, countWords } from '../../util/validators';

import sectionAddStyle from '../../assets/jss/coscef/views/articuloSections/sectionAddStyle';

const url =
  process.env.NODE_ENV === 'development'
    ? 'http://100.100.100.248:4000/'
    : 'https://api.coscef.nat.cu/';

const useStyles = makeStyles(sectionAddStyle);

const LibroAdd = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  }, []);
  const classes = useStyles();
  const [formTitulo, setFormTitulo] = useState('');
  const [formAutor, setFormAutor] = useState('');
  const [formResumen, setFormResumen] = useState('');
  const [formCaratula, setFormCaratula] = useState('');
  const [formDatos, setFormDatos] = useState('');
  const [singleImg, setSingleImg] = useState('');
  const [singleFile, setSingleFile] = useState('');
  const [fileImgProgress, setFileImgProgress] = useState(0);
  const [singleFileProgress, setSingleFileProgress] = useState(0);
  const [imgStatus, setImgStatus] = useState('Esperando fichero');
  const [fileStatus, setFileStatus] = useState('Esperando fichero');
  const [imgStatusColor, setImgStatusColor] = useState('gray');
  const [fileStatusColor, setFileStatusColor] = useState('gray');
  const [addForm, setAddForm] = useState({
    titulo: {
      value: '',
      valid: false,
      touched: false,
      validators: [isEmpty],
    },
    autor: {
      value: '',
      valid: false,
      touched: false,
      validators: [isEmpty],
    },
    resumen: {
      value: '',
      valid: false,
      touched: false,
      validators: [isEmpty, countWords({ min: 30, max: 38 })],
    },
    estado: {
      value: '',
      valid: true,
      touched: false,
      validators: [isEmpty],
    },
    caratula: {
      value: '',
      valid: true,
      touched: false,
      validators: [isEmpty],
    },
    datos: {
      value: '',
      valid: false,
      touched: false,
      validators: [isEmpty],
    },
  });
  const [formIsValid, setFormIsValid] = useState(false);
  const [caratulaIsValid, setCaratulaIsValid] = useState(false);
  const [formIsImg, setFormIsImg] = useState(false);
  const [formIsFile, setFormIsFile] = useState(false);

  // const handleSimple = (event) => {
  //   setSimpleSelect(event.target.value);
  // };

  const inputChangedHandler = (value, input) => {
    let isValid = true;

    for (let validator of addForm[input].validators) {
      isValid = isValid && validator(value);

      if (input === 'titulo') {
        if (isValid) setFormTitulo('success');
        else setFormTitulo('error');
      }
      if (input === 'autor') {
        if (isValid) setFormAutor('success');
        else setFormAutor('error');
      }
      if (input === 'resumen') {
        if (isValid) setFormResumen('success');
        else setFormResumen('error');
      }
      if (input === 'caratula') {
        if (isValid) setFormCaratula('success');
        else setFormCaratula('error');
      }
      if (input === 'datos') {
        if (isValid) setFormDatos('success');
        else setFormDatos('error');
      }
    }

    const updatedForm = {
      ...addForm,
      [input]: {
        ...addForm[input],
        valid: isValid,
        value: value,
      },
    };

    let formIsValid = true;
    for (const inputName in updatedForm) {
      formIsValid = formIsValid && updatedForm[inputName].valid;
    }

    setAddForm(updatedForm);
    setFormIsValid(formIsValid);
    if (input === 'estado' && value === 'Publicado') setCaratulaIsValid(true);
    else if (input === 'estado' && value === 'No publicado')
      setCaratulaIsValid(false);
  };

  const onImgInputChange = (inputFiles, inputFilesNames) => {
    if (inputFiles[0]) {
      setSingleImg(inputFiles[0]);
      setFormIsImg(true);
    } else {
      setSingleImg('');
      setFormIsImg(false);
    }
  };

  const onFileInputChange = (inputFiles, inputFilesNames) => {
    if (inputFiles[0]) {
      setSingleFile(inputFiles[0]);
      setFormIsFile(true);
    } else {
      setSingleFile('');
      setFormIsFile(false);
    }
  };

  const onImgUploadHandler = async () => {
    //console.log(singleFile);
    if (singleImg) {
      try {
        const config = {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: 'Bearer ' + localStorage.getItem('token'),
          },
          onUploadProgress: (progressEvent) => {
            const { loaded, total } = progressEvent;
            const percentage = Math.floor(
              ((loaded / 1000) * 100) / (total / 1000)
            );
            setFileImgProgress(percentage);
          },
        };
        const formData = new FormData();
        formData.append('img', singleImg);

        const response = await axios.post(
          url + 'api/file/img',
          formData,
          config
        );

        if (response.data) {
          //console.log(response.data);
          setImgStatus(response.data.message);
          setImgStatusColor('success');
          inputChangedHandler(response.data.url, 'caratula');
        }
      } catch (error) {
        //console.log(error.response.data);
        setImgStatus(error.response.data.message);
        setImgStatusColor('danger');
      }
    }
  };

  const onFileUploadHandler = async () => {
    //console.log(singleFile);
    if (singleFile) {
      try {
        const config = {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: 'Bearer ' + localStorage.getItem('token'),
          },
          onUploadProgress: (progressEvent) => {
            const { loaded, total } = progressEvent;
            const percentage = Math.floor(
              ((loaded / 1000) * 100) / (total / 1000)
            );
            setSingleFileProgress(percentage);
          },
        };
        const formData = new FormData();
        formData.append('arch', singleFile);
        console.log(url + 'api/file/arch');
        const response = await axios.post(
          url + 'api/file/arch',
          formData,
          config
        );

        if (response.data) {
          //console.log(response.data);
          setFileStatus(response.data.message);
          setFileStatusColor('success');
          inputChangedHandler(response.data.url, 'datos');
        }
      } catch (error) {
        console.log(error);
        setFileStatus(error.response.data.message);
        setFileStatusColor('danger');
      }
    }
  };

  const onImgDeleteHandler = async () => {
    //console.log(addForm.datos.value);
    const arrayString = addForm.datos.value.split('/');
    const filename = arrayString[arrayString.length - 1];

    if (filename) {
      try {
        const config = {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
          },
        };

        const response = await axios.delete(
          url + 'api/file/img/' + filename,
          config
        );

        if (response.data) {
          //console.log(response.data);
          setImgStatus(response.data.message);
          setImgStatusColor('success');
          inputChangedHandler('', 'caratula');
        }
      } catch (error) {
        //console.log(error.response.data);
        setImgStatus(error.response.data.message);
        setImgStatusColor('danger');
      }
    }
  };

  const onFileDeleteHandler = async () => {
    //console.log(addForm.datos.value);
    const arrayString = addForm.datos.value.split('/');
    const filename = arrayString[arrayString.length - 1];

    if (filename) {
      try {
        const config = {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
          },
        };

        const response = await axios.delete(
          url + 'api/file/arch/' + filename,
          config
        );

        if (response.data) {
          setFileStatus(response.data.message);
          setFileStatusColor('success');
          inputChangedHandler('', 'datos');
        }
      } catch (error) {
        setFileStatus(error.response.data.message);
        setFileStatusColor('danger');
      }
    }
  };

  const redirectToLibros = (data) => {
    //console.log(data);
    if (data.createLibro) props.history.push('/libros');
    else console.log('Error adicionando libro');
  };

  const updateCacheAdd = (cache, { data }) => {
    const { getLibros } = cache.readQuery({
      query: GET_LIBROS,
      variables: {
        paginate: {
          numLibros: 9,
          cursor: '',
          sortBy: { field: 'createdAt', order: 'ASC' },
        },
      },
    });

    const nuevoLibro = data?.createLibro;

    if (getLibros && nuevoLibro) {
      cache.writeQuery({
        query: GET_LIBROS,
        variables: {
          paginate: {
            numLibros: 9,
            cursor: '',
            sortBy: { field: 'createdAt', order: 'ASC' },
          },
        },
        data: {
          getLibros: {
            libros: [nuevoLibro, ...getLibros?.libros],
          },
        },
      });
    }
  };

  const [
    createLibro,
    { loading: loadingAddLibro, error: errorAddLibro, data: dataAddLibro },
  ] = useMutation(ADD_LIBRO, {
    errorPolicy: 'all',
    update: updateCacheAdd,
    onCompleted: (data) => redirectToLibros(data),
  });

  const adicionarHandler = (event) => {
    event.preventDefault();

    const libroData = {};
    for (let i in addForm) {
      if (i === 'estado' && addForm[i].value === '')
        libroData[i] = 'No publicado';
      else libroData[i] = addForm[i].value;
    }

    createLibro({
      variables: {
        input: {
          titulo: libroData.titulo,
          autor: libroData.autor,
          resumen: libroData.resumen,
          estado: libroData.estado,
          caratula: libroData.caratula,
          datos: libroData.datos,
        },
      },
    });

    //console.log(libroData);
  };

  let seccionTitulo = (
    <div className={classes.section}>
      <GridContainer justify='center'>
        <GridItem xs={12} sm={8} md={8}>
          <h2 className={classes.title}>Crear Libro</h2>
        </GridItem>
      </GridContainer>
    </div>
  );

  let seccionButton = (
    <GridContainer>
      <GridItem
        md={4}
        sm={4}
        className={classNames(
          classes.mrAuto,
          classes.mlAuto,
          classes.textCenter
        )}
      >
        <Button type='submit' color='dark' round disabled={!formIsValid}>
          Crear Libro
        </Button>
      </GridItem>
    </GridContainer>
  );

  let seccionFormulario = (
    <div id='formularioAdd'>
      <GridContainer>
        <GridItem
          md={8}
          sm={8}
          className={classNames(classes.mrAuto, classes.mlAuto)}
        >
          <form onSubmit={adicionarHandler}>
            <GridContainer>
              <GridItem md={12} sm={12}>
                <CustomInput
                  labelText='Título (*)'
                  success={formTitulo === 'success'}
                  error={formTitulo === 'error'}
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    onChange: (event) => {
                      inputChangedHandler(event.target.value, 'titulo');
                    },
                  }}
                />
              </GridItem>
              <GridItem md={12} sm={12}>
                <CustomInput
                  labelText='Autor (*)'
                  success={formAutor === 'success'}
                  error={formAutor === 'error'}
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    onChange: (event) => {
                      inputChangedHandler(event.target.value, 'autor');
                    },
                  }}
                />
              </GridItem>
              <GridItem md={12} sm={12}>
                <CustomInput
                  labelText='Resumen (De 30 a 38 palabras)'
                  success={formResumen === 'success'}
                  error={formResumen === 'error'}
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    onChange: (event) => {
                      inputChangedHandler(event.target.value, 'resumen');
                    },
                    multiline: true,
                    rows: 6,
                  }}
                />
              </GridItem>
              <GridItem md={3} sm={3}>
                <div className={classes.control1}>
                  <FormControl fullWidth className={classes.selectFormControl}>
                    <InputLabel
                      htmlFor='estado-select'
                      className={classes.selectLabel}
                    >
                      Estado del Libro
                    </InputLabel>
                    <Select
                      MenuProps={{
                        className: classes.selectMenu,
                      }}
                      classes={{
                        select: classes.select,
                      }}
                      //value={simpleSelect}
                      onChange={(event) => {
                        inputChangedHandler(event.target.value, 'estado');
                      }}
                      inputProps={{
                        name: 'estadoSelect',
                        id: 'estado-select',
                      }}
                    >
                      <MenuItem
                        disabled
                        classes={{
                          root: classes.selectMenuItem,
                        }}
                      >
                        Estado del Libro
                      </MenuItem>
                      <MenuItem
                        classes={{
                          root: classes.selectMenuItem,
                          selected: classes.selectMenuItemSelected,
                        }}
                        value='No publicado'
                      >
                        No publicado
                      </MenuItem>
                      <MenuItem
                        classes={{
                          root: classes.selectMenuItem,
                          selected: classes.selectMenuItemSelected,
                        }}
                        value='Publicado'
                      >
                        Publicado
                      </MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </GridItem>
              {caratulaIsValid ? (
                <GridItem md={9} sm={9}>
                  <div className={classes.control}>
                    <CustomFileInput
                      id={'img'}
                      onChange={onImgInputChange}
                      success={formCaratula === 'success'}
                      error={formCaratula === 'error'}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        placeholder: 'Caratula del Libro (*)',
                      }}
                    />
                    <div>
                      <div className={classes.circleBar}>
                        <CircularProgressbar
                          value={fileImgProgress}
                          text={`${fileImgProgress}%`}
                          style={buildStyles({
                            rotation: 0.25,
                            strokeLinecap: 'butt',
                            textSize: '12px',
                            pathTransitionDuration: 0.5,
                            pathColor: `rgb(62, 152, 199, ${
                              fileImgProgress / 100
                            })`,
                            textColor: '#4caf50',
                            trailColor: '#d6d6d6',
                            backgroundColor: '#dff0d8',
                          })}
                        />
                      </div>
                      <Badge
                        className={classes.marginLeft20}
                        color={imgStatusColor}
                      >
                        {imgStatus}
                      </Badge>
                      <Button
                        color='dark'
                        round
                        justIcon
                        simple
                        disabled={!addForm.caratula.value}
                        onClick={onImgDeleteHandler}
                      >
                        <i className='fa fa-trash' />
                      </Button>
                      <Button
                        color='dark'
                        round
                        className={classes.floatRight}
                        disabled={!formIsImg}
                        onClick={onImgUploadHandler}
                      >
                        Subir Caratula
                      </Button>
                    </div>
                  </div>
                </GridItem>
              ) : null}
              <GridItem md={12} sm={12}>
                <div className={classes.control}>
                  <CustomFileInput
                    id={'arch'}
                    onChange={onFileInputChange}
                    success={formDatos === 'success'}
                    error={formDatos === 'error'}
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      placeholder: 'Datos del Libro (*)',
                    }}
                  />
                  <div>
                    <div className={classes.circleBar}>
                      <CircularProgressbar
                        value={singleFileProgress}
                        text={`${singleFileProgress}%`}
                        style={buildStyles({
                          rotation: 0.25,
                          strokeLinecap: 'butt',
                          textSize: '12px',
                          pathTransitionDuration: 0.5,
                          pathColor: `rgb(62, 152, 199, ${
                            singleFileProgress / 100
                          })`,
                          textColor: '#4caf50',
                          trailColor: '#d6d6d6',
                          backgroundColor: '#dff0d8',
                        })}
                      />
                    </div>
                    <Badge
                      className={classes.marginLeft20}
                      color={fileStatusColor}
                    >
                      {fileStatus}
                    </Badge>
                    <Button
                      color='dark'
                      round
                      justIcon
                      simple
                      disabled={!addForm.datos.value}
                      onClick={onFileDeleteHandler}
                    >
                      <i className='fa fa-trash' />
                    </Button>
                    <Button
                      color='dark'
                      round
                      className={classes.floatRight}
                      disabled={!formIsFile}
                      onClick={onFileUploadHandler}
                    >
                      Subir Datos
                    </Button>
                  </div>
                </div>
              </GridItem>
            </GridContainer>
            {seccionButton}
          </form>
        </GridItem>
      </GridContainer>
    </div>
  );
  let showNotification = null;

  if (loadingAddLibro) seccionButton = <Spinner color='gray' />;

  if (errorAddLibro) {
    showNotification = errorAddLibro.graphQLErrors.map(
      ({ message, status, code }) => (
        <Notification
          key={code}
          mostrar={errorAddLibro ? true : false}
          msg={message}
          stt={status}
        />
      )
    );
  }

  if (dataAddLibro && dataAddLibro.createLibro) {
    const { createLibro } = dataAddLibro;
    if (createLibro.success && createLibro.code === '201') {
      showNotification = (
        <Notification
          key={createLibro.code}
          mostrar={createLibro.success ? true : false}
          msg={createLibro.message}
          stt={createLibro.success}
        />
      );
    }
  }

  return (
    <Fragment>
      <div
        className={classNames(classes.main, classes.mainRaised)}
        id='main-panel'
      >
        <div className={classes.sections}>
          <div className={classes.sectionWhite}>
            <div>
              <div className={classes.container}>
                {seccionTitulo}
                <div className={classes.marginTop35}>{seccionFormulario}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={classes.sectionfinal}>{showNotification}</div>
    </Fragment>
  );
};

export default withRouter(LibroAdd);
